// extracted by mini-css-extract-plugin
module.exports = {"brand":"#f96302","darkBrand":"#c14c00","primary":"#666","darkbrandtierbadge":"#c95627","primarytierbadge":"#6c6d6d"};